const baseURL = 'https://znayeshapi.pythonanywhere.com/api/v1.0/send_bot'
const validator =
  'NzU1NTE3NzU3OTpBQUdEYTlxUlc4S1VUQm5JSDNsSVRsMGJLNFNIZWxuREdBbw=='
const chatId = '-1002336263638'

export { baseURL, chatId, validator }
